export const openOptionsMenu = optionsMenuSetup => ({
  type: 'OPEN_OPTIONS_MENU',
  optionsMenuSetup
});

export const closeOptionsMenu = () => ({
  type: 'CLOSE_OPTIONS_MENU'
});
